import React, { FC } from 'react';
import { MATERIAL_ICON_MARKETING } from '../../shared/common/Button/Icon';
import {
    BUSINESS_INTELLIGENCE,
    CAMPAIGN_PRODUCTS,
    COLLECTION_NAVIGATION_V2,
    isFeatureEnabled,
    useFeature,
    USER_MANAGEMENT
} from '../../shared/utils/togglz';
import { LinkContainer } from '../../shared/navigation/NavigationLinksContainer';
import SubNavigationLayout from '../../shared/navigation/SubNavigationLayout';
import { NavigationLink } from '../../shared/navigation/NavigationLink';
import { useEnvironment } from '../../shared/components/EnvironmentContext';
import { ENVIRONMENT_DEMO } from '../../constants';
import { useTranslation } from 'react-i18next';

const YourBorrowBoxNavigation: FC = () => {
    const isCampaignsEnabled = useFeature(CAMPAIGN_PRODUCTS);
    const isCollectionNavigationV2Enabled = useFeature(COLLECTION_NAVIGATION_V2);
    const isUserManagementEnabled = useFeature(USER_MANAGEMENT);
    // CatMan is not available in the demo environment
    const isLibraryManagedProductGroupsEnabled = useEnvironment() !== ENVIRONMENT_DEMO;
    const { t } = useTranslation();

    return (
        <SubNavigationLayout
            width="0"
            isSticky={false}
            center={
                <LinkContainer>
                    {isCollectionNavigationV2Enabled ? (
                        <>
                            <li>
                                <NavigationLink to="/collectionmgmt" className="material-link">
                                    <span>{t('menu.yourBorrowbox.collectionManagementMain')}</span>
                                </NavigationLink>
                            </li>
                            <li>
                                <NavigationLink to="/merchandising" className="material-link">
                                    <span>{t('menu.yourBorrowbox.merchandisingMain')}</span>
                                </NavigationLink>
                            </li>
                            {isUserManagementEnabled ? (
                                <li>
                                    <NavigationLink to="/usermanagement" className="material-link">
                                        <span>{t('menu.yourBorrowbox.userManagement')}</span>
                                    </NavigationLink>
                                </li>
                            ) : null}
                            <li>
                                {isFeatureEnabled(BUSINESS_INTELLIGENCE) ? (
                                    <NavigationLink to="/reporting" className="material-link">
                                        <span>{t('menu.yourBorrowbox.reporting')}</span>
                                    </NavigationLink>
                                ) : (
                                    <NavigationLink
                                        href="https://bo.bolindadigital.com/wldcs_bo/login.do"
                                        external={true}
                                        className="material-link"
                                    >
                                        <span>{t('menu.yourBorrowbox.reporting')}</span>
                                    </NavigationLink>
                                )}
                            </li>
                        </>
                    ) : (
                        <>
                            <li>
                                <NavigationLink to="/collection" className="material-link">
                                    <i className="bolinda-icons" aria-hidden={true}>
                                        your_collection
                                    </i>
                                    <span>{t('menu.yourBorrowbox.yourCollectionMain')}</span>
                                </NavigationLink>
                            </li>
                            <li>
                                <NavigationLink to="/localcontent">
                                    <i className="material-icons" aria-hidden={true}>
                                        place
                                    </i>
                                    <span>{t('menu.yourBorrowbox.yourLocalContentMain')}</span>
                                </NavigationLink>
                            </li>
                            <li>
                                {isFeatureEnabled(BUSINESS_INTELLIGENCE) ? (
                                    <NavigationLink to="/reporting" external={false} className="material-link">
                                        <i className="material-icons" aria-hidden={true}>
                                            assessment
                                        </i>
                                        <span>{t('menu.yourBorrowbox.reporting')}</span>
                                    </NavigationLink>
                                ) : (
                                    <NavigationLink
                                        href="https://bo.bolindadigital.com/wldcs_bo/login.do"
                                        external={true}
                                        className="material-link"
                                    >
                                        <i className="material-icons" aria-hidden={true}>
                                            assessment
                                        </i>
                                        <span>{t('menu.yourBorrowbox.reporting')}</span>
                                    </NavigationLink>
                                )}
                            </li>
                            {isCampaignsEnabled || isLibraryManagedProductGroupsEnabled ? (
                                <li>
                                    <NavigationLink to="/marketing" className="material-link">
                                        <i className="material-icons" aria-hidden={true}>
                                            {MATERIAL_ICON_MARKETING}
                                        </i>
                                        <span>{t('menu.yourBorrowbox.marketingMain')}</span>
                                    </NavigationLink>
                                </li>
                            ) : null}
                        </>
                    )}
                </LinkContainer>
            }
        />
    );
};

export default YourBorrowBoxNavigation;
